import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import Masked from 'react-text-mask';
import omit from 'lodash/omit';
import TextField from '../TextField/index.js';

var MaskedField = function MaskedField(_a) {
  var maskedFieldProps = _a.maskedFieldProps,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      props = __rest(_a, ["maskedFieldProps", "onBlur", "onChange"]);

  return React.createElement(Masked, __assign({
    render: function render(ref, renderProps) {
      var passThroughRenderProps = omit(renderProps, 'defaultValue');
      return React.createElement(TextField, __assign({
        ref: ref
      }, props, passThroughRenderProps));
    },
    // These two handlers are wrapped by `react-text-mask` and passed back down to the
    //   underlying <TextField> via the `renderProps` above.
    onBlur: onBlur,
    onChange: onChange
  }, maskedFieldProps));
};

export default MaskedField;
//# sourceMappingURL=index.js.map
